import { useContext, useEffect, useLayoutEffect } from 'react'
import { useMediaQuery } from '@react-hookz/web'
import { StepperContext } from '~/components/ui/ViewStepper'
import { useDidMountEffect, usePrevious } from '~/utils/hooks'

export default function ViewListener({ onViewChange }) {
  const isMobile = useMediaQuery('only screen and (max-width: 969px)')
  const { id } = useContext(StepperContext)
  const prevId = usePrevious(id)

  useDidMountEffect(() => {
    if (isMobile && document.scrollingElement.scrollTop > 70) {
      document.scrollingElement.scrollTop = 70
    }
  }, [isMobile, id])

  // Layout effect, not a passive one: the module flips its fullscreen flag in this callback,
  // and a layout effect lets React re-render before the browser paints, so the new view and
  // its layout appear in the same frame instead of the view first and the reflow a beat later.
  useLayoutEffect(() => {
    if (prevId && id !== prevId) {
      if (onViewChange) onViewChange(id, prevId)
    }
  }, [id, prevId])
}
